module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<img src="' +
__e( src ) +
'" alt="' +
__e( alt ) +
'" width="32" height="32" />\n<div class="review_panel_product_text_section">\n  ';
 if (typeof tag !== 'undefined') { ;
__p += '\n    <p class="review_panel_product_tag">' +
__e( tag ) +
'</p>\n  ';
 } ;
__p += '\n  <p class="review_panel_product_name">' +
__e( name ) +
'</p>\n</div>\n<button class="remove_product_button">x</button>\n';

}
return __p
}